import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(utc);

if (environment.sentryDsn)
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.environment,
    ignoreErrors: ['Non-Error exception captured', 'ChunkLoadError'],
    tracePropagationTargets: ['localhost', environment.apiBase],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    tracesSampleRate: environment.production ? 0.05 : 1.0,
    replaysSessionSampleRate: environment.production ? 0.05 : 0,
    replaysOnErrorSampleRate: 1.0,
  });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
